var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 9.393C8.12293 11.0636 10.6172 10.7703 11.8393 9.393L14.27 6.94882C15.6437 5.4481 15.6925 3.50987 14.27 2.06047C12.8817 0.646511 10.77 0.646511 9.38168 2.06047L6.9375 4.50465",
    stroke: "#240b3b",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38117 8.2565C8.19574 6.58591 5.7149 6.79366 4.49281 8.17096L2.04863 10.5846C0.675005 12.0853 0.626121 14.0541 2.04863 15.5035C3.43693 16.9174 5.5487 16.9174 6.93699 15.5035L9.38117 13.0593",
    stroke: "#240b3b",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share_link.609c227aefc55e27cf777110fa5648fc.svg";
export { ForwardRef as ReactComponent };